<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>

    <b-card style="margin: 20px">
      <b-card-header header-tag="header" class="p-1" role="tab">
            <div class="col-md-12 text-center">
                         Ingresa el código de verificación recibido.
            </div>
        </b-card-header>
      <b-card-body>
         <div class="row form-group">
          <div class="col-md-12">
                 <label class="col-md-12 text-center">Código de verificación</label>
                 <div class="col-md-12 text-center" >
                    <pincode-input v-model="code" ref="pincode-input" secure autocomplete="off" :length="this.length" />
                 </div>
          </div>
          <div class="col-md-12 text-center" style="padding:10px;">
                    <div class="col-md-12 text-center">
                        <base-button type="danger" size="md" @click="validateCode">Validar</base-button>
                    </div>
          </div>
          <div class="col-md-12 text-center" style="padding:10px;">
                    <div class="col-md-12 text-center">
                        <base-button :disabled ="buttonResend.buttonDisabled" type="danger" size="md" id="resend"  @click="resendCode"><span>{{buttonResend.buttonText}}</span></base-button>
                    </div>
          </div>
        </div>
        
      </b-card-body>
    </b-card>
  </div>
</template>

<style type="text/css">
.input.vue-pincode-input {
 width: 50px;
  height: 50px;
  line-height: 50px;
  border-radius: 3px;
  border: 2px solid gray;
  text-align: center;
  font-size: 1.5rem;
  text-transform: uppercase;
}
 .input.vue-pincode-input:not(:last-child) {
    margin-right: 1rem;
  }

  .input.vue-pincode-input.focused {
    border-color: #000;
  }
  .input.vue-pincode-input.filled {
    border-color: dodgerblue;
    }


</style>

<script>
import axiosHelpers from "@/helpers/axiosHelpers";
import PincodeInput from 'vue-pincode-input';

export default {
  components: {"pincode-input": PincodeInput},
   props: {
        url: String,
        dataPost: Object,
        methodID: Number,
        accumulationMethodTypeID: Number,
        useRouterPush: Boolean //Indica si al validar codigo ejecuta un router.push. Caso contrario axiosPost.
      },
  data() {
    return {
       code:"" ,   
       length:6,
       buttonResend:{
         buttonText: "Reenviar Código",
         buttonDisabled: false
        },
       paramCountDown: 0,
       countDown: 0     
    };
  },
  
  methods: {
      validateCode:function(){
              let context = this;

              var param = { Code:context.code, SecurityMethodID: context.methodID, AccumulationMethodTypeID: context.accumulationMethodTypeID };
              axiosHelpers.axiosPostWithOutSecurityValidations("DoubleFactorSecurity/ValidateSecurityCode", param, this, function(data) {
                if(data.ResponseVM.Result){

                  //--Si la validación fue exitosa actualizamos UseTwoStepsTwoStepVerification para que no vuelva a saltar la verificación de 2 pasos
                  context.$store.dispatch("UpdateUseTwoStepsTwoStepVerification",  true);

                  if(context.useRouterPush){            
                    context.$router.push(context.dataPost);
                  } else {
                      axiosHelpers.axiosPostWithOutSecurityValidations(context.url, context.dataPost, context, function(dataSecondary) {
                                context.$router.push({name:"resultPage", params:{
                                  result: dataSecondary.Alerts.length > 0 ? false : true,
                                  alert:dataSecondary.Alerts.length > 0 ? dataSecondary.Alerts[0].Message : "La operación se realizó correctamente." ,
                                }});
                    });
                  }
              }
           });
      },
      resendCode:function(){
        let context = this;
        var param = { SelectedMethodID:context.methodID };
        axiosHelpers.axiosPost("DoubleFactorSecurity/GenerateSecurityCodeAndSend", param, this, (data) => { 
          if(data.ResponseVM.Result){
            context.paramCountDown = data.ResponseVM.TimeToResend;
            context.buttonResend.buttonDisabled = true;
            context.countDownTimer();
          }
        });        
      }, 
      countDownTimer() {
          let context = this;
          if(context.paramCountDown > 0) {
              setTimeout(() => {
                  context.paramCountDown -= 1;
                  if(context.paramCountDown == 1)
                    context.buttonResend.buttonText = 'Disponible en ' + context.paramCountDown.toString() + ' segundo';
                  else                                     
                    context.buttonResend.buttonText = 'Disponible en ' + context.paramCountDown.toString() + ' segundos';
                  this.countDownTimer();
              }, 1000)
          }
          else{
            context.buttonResend.buttonText = 'Reenviar Código';
            context.buttonResend.buttonDisabled = false;
          }
      }   
    },
    beforeMount: function() {

    }
  }

</script>